import { useState } from "react";

// PATCH 35 M2/M3 — a short, skippable first-time orientation. Persists "seen" per key in localStorage.
export default function OrientationTour({ tourKey, steps, testid = "orientation-tour" }) {
  const seenKey = `kadana_tour_${tourKey}`;
  const [i, setI] = useState(() => { try { return localStorage.getItem(seenKey) ? -1 : 0; } catch { return 0; } });
  if (i < 0 || !steps?.length) return null;
  const done = () => { setI(-1); try { localStorage.setItem(seenKey, "1"); } catch { /* ignore */ } };
  const step = steps[i];
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(17,17,19,.6)", zIndex: 85, display: "flex", alignItems: "center", justifyContent: "center" }} data-testid={testid}>
      <div className="k-container k-fadein" style={{ width: 440, padding: 26 }} onClick={(e) => e.stopPropagation()}>
        <div className="k-muted" style={{ fontSize: 11 }}>Step {i + 1} of {steps.length}</div>
        <h3 className="k-heading" style={{ margin: "6px 0 8px", fontSize: 19 }}>{step.title}</h3>
        <p className="k-muted" style={{ fontSize: 13.5, lineHeight: 1.6 }}>{step.body}</p>
        <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
          <button className="k-btn k-btn-ghost" data-testid={`${testid}-skip`} style={{ fontSize: 13 }} onClick={done}>Skip</button>
          <div style={{ flex: 1 }} />
          {i > 0 && <button className="k-btn k-btn-ghost" style={{ fontSize: 13 }} onClick={() => setI(i - 1)}>Back</button>}
          <button className="k-btn k-btn-primary" data-testid={`${testid}-next`} style={{ fontSize: 13 }}
            onClick={() => (i + 1 < steps.length ? setI(i + 1) : done())}>{i + 1 < steps.length ? "Next" : "Got it"}</button>
        </div>
      </div>
    </div>
  );
}
